import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogContent, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslationPipeModule } from '@ogs-gmbh/ngx-translate';

@Component({
  selector: 'app-project-staff-data-reset-dialog',
  standalone: true,
  imports: [ MatButtonModule, MatDialogContent, MatDialogModule, TranslationPipeModule ],
  templateUrl: './project-staff-data-reset-dialog.component.html',
  styleUrl: './project-staff-data-reset-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectStaffDataResetDialogComponent {
  private _dialogRef: MatDialogRef<ProjectStaffDataResetDialogComponent> = inject<MatDialogRef<ProjectStaffDataResetDialogComponent>>(MatDialogRef);

  protected confirm (): void {
    this._dialogRef.close(true);
  }

  protected cancel (): void {
    this._dialogRef.close(false);
  }
}
